import { render, staticRenderFns } from "./SaleInvoicesTable.vue?vue&type=template&id=56f25d65&"
import script from "./SaleInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports